import { schema } from "normalizr";

export const gameEntity = new schema.Entity("games");
